import { Col, Row } from 'antd';
import { DashboardOutlined, RiseOutlined, TeamOutlined, ThunderboltOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import './style.css';
import { ReportsCounters } from '../../../shared/types';

const CountersHeader = ({ data }) => {
    const [countersData, setCountersData] = useState<ReportsCounters>();

    useEffect(() => {
        setCountersData(data);
    }, [data]);

    return (
        <Row gutter={16} style={{ paddingBottom: 10, paddingTop: 30 }}>
            <Col span={24}>
                <div className="micro">
                    <div className="cards">
                        <div className="card total-trips">
                            <div className="card-content">
                                <div className="card-number">{countersData?.totalTrips}</div>
                                <div className="card-name">Total Trips</div>
                            </div>
                            <div className="icon-box">
                                <ThunderboltOutlined />
                            </div>
                        </div>

                        <div className="card total-riders">
                            <div className="card-content">
                                <div className="card-number">{countersData?.totalRiders}</div>
                                <div className="card-name">Active Riders</div>
                            </div>
                            <div className="icon-box">
                                <TeamOutlined />
                            </div>
                        </div>

                        <div className="card total-mileage">
                            <div className="card-content">
                                <div className="card-number">{countersData?.totalMileage}</div>
                                <div className="card-name">Total Mileage</div>
                            </div>
                            <div className="icon-box">
                                <DashboardOutlined />
                            </div>
                        </div>

                        <div className="card total-earnings">
                            <div className="card-content">
                                <div className="card-number">{countersData?.totalRevenue} TND</div>
                                <div className="card-name">Total Earnings</div>
                            </div>
                            <div className="icon-box">
                                <RiseOutlined />
                            </div>
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
    );
};

export default CountersHeader;
